import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../api/Axios';
import HomeNavBar from "../components/HomeNavBar";
import backgroundImg from '../assets/images/background.jpg';

// Content Section Component
const ContentSection = () => {
  return (
    <div style={{
      borderRadius: '10px',
      padding: '2rem',
      margin: '1rem 0'
    }}>
      <h1 style={{
        fontSize: '3.5rem',
        fontWeight: 'bold',
        marginBottom: '1rem',
        color: '#fff'
      }}>Password Recovery</h1>
      <p style={{
        fontSize: '1.2rem',
        lineHeight: '1.6',
        color: '#fff'
      }}>
        Forgot your password? No worries! Enter your email address and we'll send you a link to reset your password securely.
      </p>
      <p style={{
        fontSize: '1.2rem',
        lineHeight: '1.6',
        color: '#fff'
      }}>
        The password reset link will be valid for 48 hours. Make sure to check your spam folder if you don't see the email in your inbox.
      </p>
      <div style={{
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        padding: '1.5rem',
        borderRadius: '8px',
        marginTop: '1.5rem'
      }}>
        <h3 style={{ color: '#fff', marginBottom: '1rem' }}>Security Tips</h3>
        <ul style={{ color: '#fff', lineHeight: '1.8' }}>
          <li>Make sure you're entering the email address associated with your account</li>
          <li>Check your spam/junk folder if you don't receive the email within a few minutes</li>
          <li>The reset link will expire after 48 hours for security</li>
          <li>Your new password should be strong and unique</li>
        </ul>
      </div>
    </div>
  );
};

// Forgot Password Form Component
const ForgotPasswordForm = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!email) {
      setError('Please enter your email address');
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);

    try {
      await axiosInstance.post('/api/accounts/forgot-password/', {
        email: email
      });

      setEmailSent(true);
      setMessage('Password reset link sent! Please check your email.');
      
    } catch (error) {
      console.error('Forgot password request failed:', error);
      
      if (error.response) {
        const { status, data } = error.response;
        console.error('Forgot password failed with status:', status, data);
        
        if (data.error) {
          setError(data.error);
        } else if (data.email) {
          setError(Array.isArray(data.email) ? data.email.join(', ') : data.email);
        } else {
          setError(data.message || 'An error occurred. Please try again.');
        }
      } else if (error.request) {
        console.error('No response received:', error.request);
        setError('Network error. Please check your connection and try again.');
      } else {
        console.error('Request setup error:', error.message);
        setError('An error occurred. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div style={{
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderRadius: '10px',
        padding: '2rem',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        margin: '1rem 0'
      }}>
        <div style={{
          textAlign: 'center',
          fontSize: '3rem',
          color: '#28a745',
          marginBottom: '1rem'
        }}>
          ✓
        </div>
        <h2 style={{
          fontSize: '1.8rem',
          fontWeight: 'bold',
          marginBottom: '1rem',
          color: '#333',
          textAlign: 'center'
        }}>Email Sent!</h2>
        <p style={{
          fontSize: '1rem',
          lineHeight: '1.6',
          color: '#666',
          marginBottom: '1.5rem',
          textAlign: 'center'
        }}>
          We've sent a password reset link to <strong>{email}</strong>. 
          Please check your inbox and follow the instructions to reset your password.
        </p>
        <p style={{
          fontSize: '0.9rem',
          color: '#6c757d',
          marginBottom: '2rem',
          textAlign: 'center'
        }}>
          Didn't receive the email? Check your spam folder or try again in a few minutes.
        </p>
        <div style={{ textAlign: 'center' }}>
          <Link
            to="/Login"
            style={{
              display: 'inline-block',
              padding: '0.75rem 2rem',
              backgroundColor: '#007bff',
              color: '#fff',
              textDecoration: 'none',
              borderRadius: '5px',
              fontSize: '1rem',
              fontWeight: 'bold',
              transition: 'background-color 0.3s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
          >
            Back to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      borderRadius: '10px',
      padding: '2rem',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      margin: '1rem 0'
    }}>
      <h2 style={{
        fontSize: '2rem',
        fontWeight: 'bold',
        marginBottom: '1.5rem',
        color: '#333',
        textAlign: 'center'
      }}>Reset Your Password</h2>

      {message && (
        <div style={{
          padding: '1rem',
          borderRadius: '5px',
          marginBottom: '1rem',
          backgroundColor: '#d4edda',
          color: '#155724',
          border: '1px solid #c3e6cb'
        }}>
          {message}
        </div>
      )}

      {error && (
        <div style={{
          padding: '1rem',
          borderRadius: '5px',
          marginBottom: '1rem',
          backgroundColor: '#f8d7da',
          color: '#721c24',
          border: '1px solid #f5c6cb'
        }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{
            display: 'block',
            marginBottom: '0.5rem',
            fontWeight: 'bold',
            color: '#333'
          }}>
            Email Address *
          </label>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '0.75rem',
              border: error ? '2px solid #dc3545' : '1px solid #ddd',
              borderRadius: '5px',
              fontSize: '1rem',
              backgroundColor: '#fff'
            }}
            placeholder="Enter your email address"
          />
          <div style={{ fontSize: '0.875rem', color: '#6c757d', marginTop: '0.25rem' }}>
            Enter the email address associated with your account
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '0.75rem',
            backgroundColor: loading ? '#6c757d' : '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            fontSize: '1rem',
            fontWeight: 'bold',
            cursor: loading ? 'not-allowed' : 'pointer',
            transition: 'background-color 0.3s',
            marginBottom: '1rem'
          }}
        >
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>

        <div style={{ textAlign: 'center' }}>
          <Link
            to="/Login"
            style={{
              color: '#007bff',
              textDecoration: 'none',
              fontSize: '0.9rem'
            }}
          >
            Back to Login
          </Link>
        </div>
      </form>
    </div>
  );
};

// Main Forgot Password Page Component
const ForgotPasswordPage = () => {
  return (
    <div>
      {/* Bootstrap 5 CSS Link */}
      <link 
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css" 
        rel="stylesheet" 
      />
      
      <div style={{ fontFamily: 'Arial, sans-serif' }}>
        {/* Navigation */}
        <HomeNavBar />

        {/* Hero Section */}
        <section style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${backgroundImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: 'calc(100vh - 80px)',
          display: 'flex',
          alignItems: 'center'
        }}>
          <div className="container">
            <div className="row">
              {/* Form Section (1/3) - Left side */}
              <div className="col-lg-4">
                <ForgotPasswordForm />
              </div>

              {/* Content Section (2/3) - Right side */}
              <div className="col-lg-8">
                <ContentSection />
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Bootstrap 5 JS Script */}
      <script 
        src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/js/bootstrap.bundle.min.js"
      ></script>
    </div>
  );
};

export default ForgotPasswordPage;
